prbJsonp([3],{

/***/ "./client/js/archive/archive.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jsComponentFramework = __webpack_require__("./node_modules/js-component-framework/lib/index.js");

var _loadMoreConfig = __webpack_require__("./client/js/components/LoadMore/loadMoreConfig.js");

var _loadMoreConfig2 = _interopRequireDefault(_loadMoreConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Create instance of the component manager using `wp-starter-theme`
/**
 * JS for archives (is_archive())
 */
var manager = new _jsComponentFramework.ComponentManager('prb-2017'); // eslint-disable-line no-unused-vars

// Initialize components here


// Import components and manager here
document.addEventListener('DOMContentLoaded', function () {
  manager.initComponents([_loadMoreConfig2.default]);
});

// HMR Acceptance
if (false) {
  module.hot.accept();
}

/***/ }),

/***/ "./client/js/components/LoadMore/LoadMore.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jsComponentFramework = __webpack_require__("./node_modules/js-component-framework/lib/index.js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Component for instantiating LoadMore.
 */
var LoadMore = function (_Component) {
  _inherits(LoadMore, _Component);

  /**
   * Start the component
   */
  function LoadMore(config) {
    _classCallCheck(this, LoadMore);

    // Listen for button click
    var _this = _possibleConstructorReturn(this, (LoadMore.__proto__ || Object.getPrototypeOf(LoadMore)).call(this, config));

    if (_this.children.buttonAnchor) {
      _this.children.buttonAnchor.addEventListener('click', _this.loadMoreClicked.bind(_this));
    }
    return _this;
  }

  _createClass(LoadMore, [{
    key: 'loadMoreClicked',
    value: function loadMoreClicked(event) {
      var _this2 = this;

      event.preventDefault();

      // Remove load more button
      this.children.button.style.display = 'none';

      // Get the new page
      jQuery.get(this.children.buttonAnchor.href).done(function (response) {
        // Create a dom element out of the response
        var responseDiv = document.createElement('div');
        responseDiv.innerHTML = response;

        // Get card dom elements
        var cards = responseDiv.querySelectorAll('.article-card');
        var newUrl = responseDiv.querySelectorAll('.article-card-list__cta a');

        // Loop through cards and insert them
        for (var i = 0; i < cards.length; i += 1) {
          _this2.element.insertBefore(cards.item(i), _this2.children.button);
        }

        // Update URL and show button again
        if (1 === newUrl.length) {
          _this2.children.buttonAnchor.href = newUrl[0].href;
          _this2.children.button.style.display = '';
        }
      });
    }
  }]);

  return LoadMore;
}(_jsComponentFramework.Component);

exports.default = LoadMore;

/***/ }),

/***/ "./client/js/components/LoadMore/loadMoreConfig.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _LoadMore = __webpack_require__("./client/js/components/LoadMore/LoadMore.js");

var _LoadMore2 = _interopRequireDefault(_LoadMore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var loadMoreConfig = {
  name: 'loadMore',
  class: _LoadMore2.default,
  querySelector: {
    buttonAnchor: '.article-card-list__cta a',
    button: '.article-card-list__cta'
  }
};

exports.default = loadMoreConfig;

/***/ }),

/***/ 3:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./client/js/archive/archive.js");


/***/ })

},[3]);


// WEBPACK FOOTER //
// js/archive.46d7bf5.bundle.min.js